/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_LevelInputs */

const en_us2_profile_row_level = /** @type {(inputs: Profile_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const pt_br2_profile_row_level = /** @type {(inputs: Profile_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const es_419_profile_row_level = /** @type {(inputs: Profile_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const pt_pt2_profile_row_level = /** @type {(inputs: Profile_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const fr_fr2_profile_row_level = /** @type {(inputs: Profile_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const de_de2_profile_row_level = /** @type {(inputs: Profile_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const it_it2_profile_row_level = /** @type {(inputs: Profile_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Profile_Row_LevelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_level = /** @type {((inputs?: Profile_Row_LevelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_LevelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_level(inputs)
	if (locale === "es-419") return es_419_profile_row_level(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_level(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_level(inputs)
	if (locale === "de-DE") return de_de2_profile_row_level(inputs)
	if (locale === "it-IT") return it_it2_profile_row_level(inputs)
	return en_us2_profile_row_level(inputs)
});
export { profile_row_level as "profile.row_level" }